import { useState } from "react";
import MembershipDetailedSection from "./Memberships/MembershipDetailedSection";
import membershipLight from "@/assets/images/memberships/membership-light.png";
import membershipDark from "@/assets/images/memberships/membership-dark.png";
import coreAnimation from "@/assets/images/memberships/core-animation.mp4";
import apexAnimation from "@/assets/images/memberships/apex-animation.mp4";
import coreMobile from "@/assets/images/memberships/core-mobile.png";
import apexMobile from "@/assets/images/memberships/apex-mobile.png";
import { type CompareProgramsModalTabKey } from "@/components/Memberships/CompareProgramsModal";
import {
  coreStats,
  apexStats,
  coreFeatures,
  apexFeatures,
  journey,
} from "@/data/membershipsPageData";
import FAQSection from "@/components/FAQSection";
import MembershipsSection from "@/components/Memberships/Memberships";
import { COLLAPSABLE_CONTENT_HOME_FAQ_VALUES } from "@/components/Collapsible/constants";

const coreIdealFor = [
  "Pilno sveikatos įvertinimo",
  "Subalansuotos energijos ir miego",
  "Kasdienio streso ir savijautos kontrolės",
  "Aiškaus, gydytojų pagrįsto ir prižiūrimo veiksmų plano",
];

const apexIdealFor = [
  "Visko CORE narystėje",
  "Paveldimų ligų rizikų valdymo",
  "Pakartotinių tyrimų ir pokyčio stebėjimo",
  "Nuolatinės priežiūros ir sprendimų koregavimo",
];

const MembershipsPage = () => {
  const [isCompareOpen, setIsCompareOpen] = useState(false);
  const [compareOpenToTab, setCompareOpenToTab] =
    useState<CompareProgramsModalTabKey>("vertinimai");

  return (
    <div className="bg-primary flex w-full flex-col items-center">
      <div className="mx-auto flex w-full max-w-[600px] flex-col items-center gap-6 px-4 pt-25 text-center md:pt-45">
        <h1 className="text-dark text-[34px] leading-[1.2] font-light md:text-[44px]">
          Telomera Narystės
        </h1>
        <p className="text-dark text-[18px] leading-[1.4]">
          Siūlome du narystės lygius, kurie skiriasi diagnostikos, pakartotinių
          tyrimų ir klinikinės komandos apimtimi
        </p>
      </div>

      <MembershipsSection
        cardVariant="page"
        showCTA={false}
        isCompareOpen={isCompareOpen}
        onCompareOpenChange={setIsCompareOpen}
        compareOpenToTab={compareOpenToTab}
        onCompareOpenToTabChange={setCompareOpenToTab}
        renderCompareModal
      />

      <div className="mx-auto flex w-full max-w-[1220px] flex-col gap-[80px] px-0 pb-10 md:pb-20">
        <div id="core" className="scroll-mt-20">
          <MembershipDetailedSection
            variant="light"
            label="TELOMERA CORE"
            title="Jūsų sveikatos pagrindas geresniam gyvenimui"
            stats={coreStats}
            heroImage={membershipLight}
            heroImageMobile={coreMobile}
            cardImage={membershipLight}
            cardBackgroundVideoSrc={coreAnimation}
            cardTitle="CORE"
            price="€2500"
            idealForTitle="Idealiai tinka tiems, kurie nori:"
            idealFor={coreIdealFor}
            featuresTitle="Kas įtraukta į CORE"
            features={coreFeatures}
            journeyTitle="Jūsų CORE kelionė"
            journey={journey}
            onCompare={() => {
              setCompareOpenToTab("vertinimai");
              setIsCompareOpen(true);
            }}
            journeyMaxVisibleSteps={3}
            onJourneyMore={() => {
              setCompareOpenToTab("kelione");
              setIsCompareOpen(true);
            }}
          />
        </div>
      </div>

      <div id="apex" className="w-full scroll-mt-20">
        <MembershipDetailedSection
          variant="dark"
          label="TELOMERA APEX"
          title="Sveikatos valdymas be kompromisų"
          stats={apexStats}
          heroImage={membershipDark}
          heroImageMobile={apexMobile}
          cardImage={membershipDark}
          cardBackgroundVideoSrc={apexAnimation}
          cardTitle="APEX"
          price="€3900"
          idealForTitle="Idealiai tinka tiems, kurie nori:"
          idealFor={apexIdealFor}
          featuresTitle="Kas įtraukta į APEX"
          features={apexFeatures}
          journeyTitle="Jūsų APEX kelionė"
          journey={journey}
          onCompare={() => {
            setCompareOpenToTab("vertinimai");
            setIsCompareOpen(true);
          }}
          journeyMaxVisibleSteps={3}
          onJourneyMore={() => {
            setCompareOpenToTab("kelione");
            setIsCompareOpen(true);
          }}
        />
      </div>

      <div className="mb-10 w-full md:mb-20">
        <MembershipsSection
          isCompareOpen={isCompareOpen}
          onCompareOpenChange={setIsCompareOpen}
          compareOpenToTab={compareOpenToTab}
          onCompareOpenToTabChange={setCompareOpenToTab}
          renderCompareModal={false}
        />
      </div>

      <div className="w-full">
        <FAQSection data={COLLAPSABLE_CONTENT_HOME_FAQ_VALUES.items} />
      </div>
    </div>
  );
};

export default MembershipsPage;
